import templateStr from 'text!./change-policy.html';
import moment from 'moment';
import LocalDateUtil from 'gw-portals-util-js/LocalDateUtil';

export default () => {
    return {
        restrict: 'A',
        template: templateStr,
        transclude: true,
        scope: {
            latestPeriod: '=',
            hideForm: '&'
        },
        controller: ['$state', '$scope', 'PolicyService', 'UserService', 'CancellationService', '$window', '$q', 'ModalService', 'ViewModelService', 'GPA_PC_ENTRY_POINT', '$filter', ($state, $scope, PolicyService, UserService, CancellationService, $window, $q, ModalService, ViewModelService, GPA_PC_ENTRY_POINT, $filter) => {

            $scope.acccessingXCenter = false;
            $scope.transferringMsg = 'gateway.directives.change-policy.Transferring to PolicyCenter';

            const today = LocalDateUtil.today();
            $scope.today = new Date(Date.UTC(today.year, today.month, today.day, 0, 0, 0, 0));
            const effectiveDate = ($scope.today > new Date($scope.latestPeriod.effectiveDate)) ? $scope.today : $scope.latestPeriod.effectiveDate;

            $scope.policyChange = {
                'policyNumber': $scope.latestPeriod.policyNumber,
                'effectiveDate': effectiveDate,
                'description': ''
            };
            $scope.effectiveDateValidation = {
                'isValid': false,
                'validationErrorMessage': ''
            };

            $scope.policyChangeView = ViewModelService.create($scope.policyChange, 'pc', 'edge.capabilities.gateway.job.policychange.dto.PolicyChangeDTO');

            function createPolicyChange() {
                const newPolicyChangeRequest = PolicyService.createNewPolicyChangeTransaction($scope.policyChange);
                $scope.newPolicyChangeRequest = newPolicyChangeRequest;
                $scope.acccessingXCenter = true;

                newPolicyChangeRequest.then(
                    (job) => {
                        $window.location.href = `${GPA_PC_ENTRY_POINT}?JobNumber=${job.jobNumber}`;
                    },
                    (error) => {
                        ModalService.showError('gateway.views.modal.Error', error.baseError.data.error.message);
                        $scope.acccessingXCenter = false;
                    }
                );
            }

            $scope.startPolicyChange = (form) => {
                form.submitted = true;
                $scope.validateEffectiveDate();
                if (!form.invalid && $scope.effectiveDateValidation.isValid) {
                    createPolicyChange();
                }
            };

            $scope.$watch('policyChange.effectiveDate', () => {
                if ($scope.policyChange.effectiveDate) {
                    $scope.validateEffectiveDate();
                }
            });

            $scope.validateEffectiveDate = () => {
                // check if new effective date is within the latestPeriod expiry and effective date
                const latestPeriodExpiryDate = moment($scope.latestPeriod.expirationDate);
                const chosenEffectiveDate = moment($scope.policyChange.effectiveDate);
                if (chosenEffectiveDate.isBefore(moment())) {
                    $scope.effectiveDateValidation.isValid = false;
                    $scope.effectiveDateValidation.validationErrorMessage = $filter('translate')('gateway.directives.change-policy.Please set a date that is after the start date of the policy');
                    return;
                }
                if (chosenEffectiveDate.isAfter(latestPeriodExpiryDate)) {
                    $scope.effectiveDateValidation.isValid = false;
                    $scope.effectiveDateValidation.validationErrorMessage = $filter('translate')('gateway.directives.change-policy.Please set a date that is before the expiry date of the policy');
                    return;
                }
                $scope.effectiveDateValidation.isValid = true;
                $scope.effectiveDateValidation.validationErrorMessage = '';
            };
        }]
    };
};
